import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";

import AccountCircle from "@material-ui/icons/AccountCircle";

import { Link as RouterLink } from "react-router-dom";

import { logoutUser } from "../../store/actions/auth";
import Axios from "../../utils/axios";
import { AUTH_LOGOUT_URL } from "../../config";

const useStyles = makeStyles(theme => ({
  paper: {
    margin: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    // margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main
  }
}));

export default function User() {
  const dispatch = useDispatch();
  const username = useSelector(state => state.auth.name);
  const classes = useStyles();

  const logoutButtonClick = e => {
    e.preventDefault();
    const axiosInstance = new Axios("public");
    axiosInstance
      .request({ url: AUTH_LOGOUT_URL.url, method: AUTH_LOGOUT_URL.method })
      .then(() => {
        dispatch(logoutUser());
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <AccountCircle />
        </Avatar>
        <h3>{username}</h3>
        <Box display="flex" flexWrap="no-wrap">
          <Link component={RouterLink} to="/profile/change-pwd">
            <IconButton
              className={classes.button}
              aria-label="settings"
              size="small"
            >
              <SettingsIcon />
            </IconButton>
          </Link>
          <Link onClick={logoutButtonClick} underline="none">
            <IconButton
              className={classes.button}
              aria-label="logout"
              size="small"
            >
              <ExitToAppIcon />
            </IconButton>
          </Link>
        </Box>
      </div>
    </Container>
  );
}
